import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import App from './App';
import { applyTheme, initialTheme } from './components/ThemeToggle';
import './styles.css';
// After styles.css on purpose: where a .pub rule and a dashboard rule have
// equal specificity, the public theme has to win inside its own subtree.
import './public/public.css';

// Before the first render, so the opening paint is already the right theme.
// Done here rather than in a component effect because an effect runs after paint,
// and a flash of the wrong theme on every load is worse than a slow toggle.
applyTheme(initialTheme());

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
